import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UiHelper } from '@app/helpers/ui.helper';
import { UserHelper } from '@app/helpers/user.helper';
import { ApiService } from '@app/services/api.service';
@Component({
  selector: 'casino-routing-dialog',
  templateUrl: '../sharedTemplates/casino-routing-dialog.html',
})
export class CasinoRoutingDialog {
  constructor(public dialogRef: MatDialogRef<CasinoRoutingDialog>, private _UiHelper: UiHelper, public _UserHelper: UserHelper, private _ApiService: ApiService) {}

  yesClick(): void {
    this._ApiService.sonnenspieleCasinoLaunch().then(result => {
      if (result && result.data) {
        if (result.success) {
          window.location.href = result.data;
        } else {
          this._UiHelper.errorSnackBar(result.data, '');
        }
      }
    });
  }
}
